/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Change_CaseInputs */



/**
* | output |
* | --- |
* | "Change Case" |
*
* @param {Change_CaseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const change_case = /** @type {((inputs?: Change_CaseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Change_CaseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Casse")
	if (locale === "de") return /** @type {LocalizedString} */ ("Groß-/Kleinschreibung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Maiuscole/minuscole")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Регистр")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mayúsculas y minúsculas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("大小写")
	if (locale === "ja") return /** @type {LocalizedString} */ ("大文字と小文字")
	if (locale === "hi") return /** @type {LocalizedString} */ ("केस बदलें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Maiúsculas/minúsculas")
	return /** @type {LocalizedString} */ ("Change Case")
});